import { Accordion, AccordionSummary, Typography, AccordionDetails, Button, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BadgeNumber from 'components/BadgeNumber';
import FormBuilder from 'containers/FormBuilder';
import { Form2Section2Fields } from 'constants/form-2-section-2-fields';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useController } from 'react-hook-form';
import CircularIcon from 'components/CircularIcon';
import DoneIcon from '@mui/icons-material/Done';
import BottomButton from 'components/BottomButton';

export default function FormStep2Section2Container() {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section') || '1';
  const { field, fieldState, formState } = useController({ name: 'entity.managements' });
  const [userCount, setUserCount] = useState(Array.isArray(field.value) ? field.value.length : 0);
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

  useEffect(() => {
    setIsAccordionExpanded(section === '2');
  }, [section]);

  useEffect(() => {
    if (fieldState.error) {
      setIsAccordionExpanded(true);
    }
  }, [fieldState.error]);

  const onDeleteUser = (index: number) => {
    setUserCount((prev) => prev - 1);
    field.onChange(field.value.filter((_: unknown, i: number) => i !== index));
  };

  const AddUserButton = () => (
    <Button
      color="primary"
      variant="outlined"
      startIcon={<PersonAddOutlinedIcon />}
      onClick={() => setUserCount((prev) => prev + 1)}
      fullWidth
    >
      Tambahkan pengurus lain
    </Button>
  );

  const HeaderElement = ({ index, canDelete }: { index: number; canDelete: boolean }) => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb: 3 }}>
        <Typography color="surface.700" variant="h6" component="p">
          Pengurus {index + 1}
        </Typography>
        {canDelete ? (
          <Button
            color="primary"
            variant="outlined"
            startIcon={<DeleteOutlineOutlinedIcon />}
            onClick={() => onDeleteUser(index)}
          >
            Hapus Pengurus Ini
          </Button>
        ) : null}
      </Box>
    );
  };

  return (
    <Accordion
      expanded={isAccordionExpanded}
      onChange={() => ['3', '2'].includes(section) && setIsAccordionExpanded((prev) => !prev)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        {section <= '2' ? (
          <BadgeNumber>2</BadgeNumber>
        ) : (
          <CircularIcon>
            <DoneIcon />
          </CircularIcon>
        )}
        <Typography color="surface.700" variant="h6" sx={{ marginLeft: 1 }} component="p">
          Manajemen
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography color="surface.700" component="h1" sx={{ mb: 1 }}>
          Mohon untuk menyediakan informasi mengenai pengurus berwenang sesuai dengan AD ART dan dokumen identitas yang
          berlaku pada kolom di bawah ini. Pengurus berwenang wajib melakukan video call dengan petugas Bank.
        </Typography>
        {['3', '2'].includes(section) &&
          [...Array(userCount)].map((_, index) => {
            const isLast = index === userCount - 1;
            const isNotFirst = index !== 0;
            const isNotMoreThanFifteen = index <= 13; // Pengurus 1 is the default one, so we can only add 14 more
            return (
              <FormBuilder
                key={`${index}-${field.value[index]?.name}`}
                formFields={Form2Section2Fields(index)}
                headerElement={<HeaderElement index={index} canDelete={isNotFirst} />}
                footerElement={isLast && isNotMoreThanFifteen ? <AddUserButton /> : <></>}
              />
            );
          })}
      </AccordionDetails>
      {section === '2' && <BottomButton isButtonLoading={formState.isSubmitting} />}
    </Accordion>
  );
}
